<template>

  <div class="view pa24">
    <div class="d-flex">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <div class="d-flex align-items-center">
            <el-input v-model="name" class="mb10" style="width: 240px" placeholder="请输入产品类别名称" clearable />
            <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>
            <el-button class="ml10 mb10" type="primary" @click="handleEditBom(null)">+添加BOM</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.items">
            <el-table-column label="序号" align="center">
              <template slot-scope="scope">
                <!-- 子表格序号从 1 开始依次递增 -->
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" />
            <el-table-column prop="specName" align="center" label="规格" />
            <el-table-column prop="type" align="center" label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type===0" style="color: green;">产品</span>
                <span v-else-if="scope.row.type===1" style="color: #ffb000;">组件</span>
                <span v-else-if="scope.row.type===2" style="color: #f86666;">零件</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column prop="num" align="center" label="数量" />
          </el-table>
        </template>
      </el-table-column>

      <!-- 修改序号列，使用 index 动态计算序号 -->
      <el-table-column label="序号" align="center">
        <template slot-scope="scope">
          <!-- 计算当前页的起始序号，再加上当前行在本页的索引 -->
          {{ (pageNum - 1) * pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="specName" align="center" label="规格" />
      <el-table-column prop="type" align="center" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type===0" style="color: green;">产品</span>
          <span v-else-if="scope.row.type===1" style="color: #ffb000;">组件</span>
          <span v-else-if="scope.row.type===2" style="color: #f86666;">零件</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="num" align="center" label="数量" />
      <el-table-column prop="createTime" align="center" label="创建时间" />
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEditBom(scope.row)">编辑</el-button>
          <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" @confirm="handleDelBom(scope.row.id)"
            icon="el-icon-info" icon-color="red" title="确定要删除吗？">
            <el-button slot="reference" class="ml10" style="color: #fd634e" type="text">删除</el-button>

          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="pageBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNum" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
        :total="total" :pager-count="5" />
    </div>
    <AddPageClassDialog ref="addPageClassDialog" @getList="getList"></AddPageClassDialog>
  </div>
</template>
<script>
  import { del, query } from '@/api/boomClass.js'
  import AddPageClassDialog from './component/AddPageClassDialog'
  export default {
    components: {
      AddPageClassDialog
    },
    props: {
    },
    data() {
      return {
        name: null,
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        form: {
        },
      };
    },
    created() {
      this.getList()
    },
    methods: {

      getCustomer() {
        this.getList()
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          name: this.name,
        }
        query(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
      },
      handleEditBom(row) {
        this.$refs.addPageClassDialog.openDialog(row)
      },
      handleDelBom(id) {
        del(id).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getList()
        })
      }
    },
  }
</script>
<style scoped>
  .pageBox {
    display: flex;
    justify-content: flex-end;
  }
</style>